export default {
    methods: {
        referenceReadable(ref){
            return String(ref).substring(0, 9).replace(/(?!^)(?=(?:.{3})+(?:\.|$))/gm, ' ');
        },
        dateTimeReadable(date){ return this.$dayjs(date).format('dddd Do MMMM YYYY à HH:mm'); },
        dateReadable(date){ return this.$dayjs(date).format('dddd Do MMMM YYYY'); },
        // parseDateTimeLong(date){ return this.$dayjs(date).format("dddd DD MMMM YYYY à HH:mm"); },
        // parseDateLong(date){ return this.$dayjs(date).format("dddd DD MMMM YYYY"); }
        parseDateTimeShort(date){ return this.$dayjs(date).format("DD-MM-YYYY HH:mm"); },
        parseDateTimeShortSlash(date){ return this.$dayjs(date).format("DD/MM/YYYY HH:mm"); },
        parseDateTimeMix(date){ return this.$dayjs(date).format("DD MMM YYYY HH:mm"); },
        parseDateMix(date){ return this.$dayjs(date).format("DD MMM YYYY"); },
        parseDateShort(date){ return this.$dayjs(date).format("DD-MM-YYYY"); },
        parseDateShortSlash(date){ return this.$dayjs(date).format("DD/MM/YYYY"); },
        parseDateTimeShortEN(date){ return this.$dayjs(date).format("YYYY-MM-DD HH:mm"); },
        parseDateShortEN(date){ return this.$dayjs(date).format("YYYY-MM-DD"); },
        parseDateUTCiso(date){ return this.$dayjs(date).utc().format('YYYY-MM-DDTHH:mm:ss.SSSZZ'); },

        // Keep
        // parseTime(date){ return this.$dayjs(date).format("HH:mm"); },
        numberReadable(number, ifnull){ return number ? String(number).replace(/(?!^)(?=(?:\d{3})+(?:\.|$))/gm, ' '): ifnull; },
        dateFormatShort(date){ return this.$dayjs(date).format("YYYY-MM-DD"); },

        // New multiple locale
        parseTime(date){ return this.$dayjs(date).format("LT"); },
        parseDateLong(date){ return this.$dayjs(date).format("LL"); },
        parseDateTimeLong(date){ return this.$dayjs(date).format("LLLL"); },

        logger({ data, msg}){
            if(this.debug){
                if(msg) console.log(msg, data);
                else console.log(data);
            }
        }
    }
}
